import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useAddTransaction = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("POST");

  const addTransaction = async (walletId: any, body: any) => await makeApiRequest(`${apiBase}/api/wallets/${walletId}/transactions`, body);

  return [addTransaction];
};

export default useAddTransaction;
